import React, { useEffect, useRef, useState } from 'react'
import { SELECTED_STORAGE_KEYS } from '../../auth/core/constant'
import { usePromotionsDash } from './PromotionsDashboard'
import PromotionsFilterComp from './PromotionsFilterComp'
import { KTCard, KTCardBody, KTIcon, QueryStateI } from '../../../../general/helpers'
import ListLoading from '../dashboad/components/loading/ListLoading'
import { PageTitle } from '../../../../general/layout/core'
import Pagination from '../components/Pagination'
import { useIntl } from 'react-intl'
import { useClearSessionOnModuleEntry } from '../hooks/useClearSessionOnModuleEntry'
import { PromotionsTable } from './table/PromotionsTable'
import { scrollToBelowElement, showToast } from '../core/helper'
import { PromotionsQueryRequestProvider, usePromotionsQueryRequest } from './core/PromotionsRequestProvider'
import { PromotionsQueryResponseProvider, usePromotionsQueryResponse, usePromotionsQueryResponseData, usePromotionsQueryResponseLoading, usePromotionsQueryResponseTotalCount } from './core/PromotionsResponseProvider'
import { useAuth } from '../../auth'
import { PERMISSION_ARRKEY } from '../../auth/core/constant'
import { export_promotions } from '../core/_request'
import { toast } from 'react-toastify'


function PromotionsDashboardLayoutInner() {
  const [filterQueryStr, setFilterQueryStr] = useState<string>('')
  const [exportLoading, setExportLoading] = useState(false)

  const { isLoading, query } = usePromotionsQueryResponse()
  const { state, updateState, loading } = usePromotionsQueryRequest()
  const totalItems = usePromotionsQueryResponseTotalCount()
  const queryListings = usePromotionsQueryResponseData()
  const { getAllowedPermissionValue } = useAuth()

  const refTransactionsList = useRef(null)
  const intl = useIntl()

  const prevLoading = useRef(isLoading);

  useEffect(() => {
    sessionStorage.removeItem(SELECTED_STORAGE_KEYS.PROMOTIONS_FILTERS_KEY)
  }, [])

  useEffect(() => {
    if (prevLoading.current && !isLoading && queryListings?.length === 0) {
      toast.error(
        showToast(
          intl.formatMessage({
            id: 'TRANSACTION.EMPTY',
          })
        )
      )
    }
    prevLoading.current = isLoading
  }, [isLoading, queryListings, intl])


  const triggerPromotionsExport = async () => {
    setExportLoading(true)
    try {
      await export_promotions(query.replace('?', ''), {})
    } catch (e) {
      console.error(e)
    } finally {
      setExportLoading(false)
    }
  }

  return (
    <>
      <PageTitle>Promotion Schemes</PageTitle>
      <KTCard>
        <KTCardBody className='pt-2'>
          <PromotionsFilterComp />
        </KTCardBody>
        <div ref={refTransactionsList} />
      </KTCard>

      {queryListings?.length > 0 && (
        <KTCard className='mt-5'>
          <KTCardBody className='py-4'>
            <div className='d-flex justify-content-end mb-4'>
              {getAllowedPermissionValue(PERMISSION_ARRKEY.EXPORT_PROMOTIONS) && (
                <button
                  disabled={exportLoading}
                  type='button'
                  className='btn btn-light-primary'
                  onClick={triggerPromotionsExport}
                >
                  {!exportLoading && <KTIcon iconName='exit-up' className='fs-2' />}
                  {intl.formatMessage({ id: 'EXPORT' })}
                  {exportLoading && (
                    <span className='spinner-border spinner-border-sm align-middle text-primary ms-2' />
                  )}
                </button>
              )}
            </div>
            {loading ? (
              <ListLoading />
            ) : (
              <>
                <PromotionsTable />
                <Pagination
                  totalItems={totalItems}
                  state={state}
                  updateState={updateState}
                />
                {isLoading ? <ListLoading /> : <></>}
              </>
            )}
          </KTCardBody>
        </KTCard>
      )}
    </>
  )
}

const PromotionsDashboardLayout = () => (
  <PromotionsQueryRequestProvider>
    <PromotionsQueryResponseProvider>
      <PromotionsDashboardLayoutInner />
    </PromotionsQueryResponseProvider>
  </PromotionsQueryRequestProvider>
)

export default PromotionsDashboardLayout
